import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Loader } from "../common";
import {
  getStudentMembershipId,
  resetExternalFeePayment,
} from "../../actions";
import { isMobileDevice } from "../../helpers/Utils";
import { addDashesToPhoneNumber } from "../../helpers/Utils";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";

const IS_MOBILE = isMobileDevice();

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && StyleConstants.color.darkBlue,
  }),
};

class StudentSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      studentPhoneNumber: "",
    };
  }

  async componentDidMount() {
    this.props.resetExternalFeePayment();
  }

  render() {
    const instituteId = this.props.match.params.institute_id;
    const { studentPhoneNumber } = this.state;
    if (this.props.isLoading) {
      return <Loader />;
    }

    return (
      <div
        style={{
          margin: "70px 30px 30px 30px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: IS_MOBILE ? "80%" : "40%",
            margin: "30px auto",
            borderRadius: 3,
            border: "1px solid #ddd",
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              margin: 30,
            }}
          >
            <div
              style={{
                margin: "auto",
                fontFamily: "'Montserrat', sans-serif",
                color: "#44464c",
                marginBottom: 20,
                fontWeight: "bold",
                fontSize: 24,
              }}
            >
              Fee Payment
            </div>
            <input
              type="text"
              style={{
                margin: "10px auto",
                width: "430px",
                border: 0,
                borderBottom: "1px solid #ddd",
                borderRadius: 0,
                backgroundColor: "white",
                fontSize: 16,
              }}
              placeholder="Registered Phone Number"
              onKeyPress={(event) => event.key === "Enter"}
              onChange={(event) => {
                this.setState({ studentPhoneNumber: event.target.value });
              }}
            ></input>
            <div
              className="Button Primary-Button"
              style={{ width: 150, margin: "20px auto 0 auto" }}
              onClick={() => {
                this.props
                  .getStudentMembershipId(
                    instituteId,
                    addDashesToPhoneNumber(studentPhoneNumber)
                  )
                  .then((response) => {
                    if (response.success) {
                      this.props.history.push(
                        `/external_fee_payment/${instituteId}/${this.props.selectedStudentId}`
                      );
                    }
                  });
              }}
            >
              Continue
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StudentSelection.propTypes = {
  institutesList: PropTypes.array,
  selectedStudentId: PropTypes.number,
  instituteId: PropTypes.number,
};

StudentSelection.defaultProps = {
  institutesList: [],
  isLoading: false,
};

const mapStateToProps = ({ externalFeePayment }) => ({
  isLoading: externalFeePayment.isLoading,
  institutesList: externalFeePayment.institutesList,
  instituteId: externalFeePayment.instituteId,
  selectedStudentId: externalFeePayment.selectedStudentId, 
});

export default withRouter(
  connect(mapStateToProps, {
    getStudentMembershipId,
    resetExternalFeePayment,
  })(StudentSelection)
);
